export interface CommerceFormPrefill {
  name: string;
  description: string;
  url_site_web: string;
  zone: string;
  placeInput: string;
  jurisdiccionId: number | '' | null;
  logoUrl?: string;
}

export function extractUserSkillIdsFromUserData(userData: { skills?: unknown[] } | null | undefined): number[] {
  const skills = userData?.skills ?? [];
  const ids: number[] = [];
  for (const entry of skills) {
    const e = entry as { skill?: { id?: number | string }; id?: number | string; skillId?: number | string };
    const id = Number(e?.skill?.id ?? e?.id ?? e?.skillId);
    if (Number.isFinite(id)) ids.push(id);
  }
  return ids;
}

export function buildCommercePrefillFromUserData(userData: {
  type?: string;
  name?: string;
  last_name?: string;
  razon_social?: string;
  description?: string | null;
  url_site_web?: string | null;
  jobBoardZones?: Array<{
    allCountry?: boolean;
    city?: string | null;
    jurisdiccion?: { id?: number; name?: string };
  }>;
} | null | undefined): CommerceFormPrefill {
  if (!userData) {
    return {
      name: '',
      description: '',
      url_site_web: '',
      zone: '',
      placeInput: '',
      jurisdiccionId: '',
    };
  }
  const isCompany = userData.type === 'COMPANY';
  const name = isCompany
    ? String(userData.razon_social ?? '').trim()
    : [userData.name, userData.last_name]
        .map((x) => String(x ?? '').trim())
        .filter((x) => x.length > 0)
        .join(' ')
        .trim();
  const description = String(userData.description ?? '').trim();
  const url_site_web = String(userData.url_site_web ?? '').trim();
  const zones = userData.jobBoardZones ?? [];
  const first = zones.find((z) => !z.allCountry && (z.city || z.jurisdiccion?.name));
  const hasAllCountry = zones.some((z) => z.allCountry);
  let zone = '';
  let placeInput = '';
  let jurisdiccionId: number | '' | null = '';
  if (hasAllCountry) {
    zone = 'Argentina';
    placeInput = 'Argentina';
  } else if (first) {
    zone = String(first.city ?? first.jurisdiccion?.name ?? '').trim();
    placeInput = zone;
    const jid = first.jurisdiccion?.id;
    if (jid != null && Number.isFinite(Number(jid))) {
      jurisdiccionId = Number(jid);
    }
  }
  return {
    name,
    description,
    url_site_web,
    zone,
    placeInput,
    jurisdiccionId,
  };
}
